"use client";

import { Copy } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { copyToClipboard } from "@/lib/clipboard";

/** A labeled, copyable command / value block used across key-setup surfaces. */
export function CommandBlock({
  label,
  hint,
  command,
  copiedMessage = "Command copied",
}: {
  label: string;
  hint?: string;
  command: string;
  copiedMessage?: string;
}) {
  return (
    <div className="grid gap-1.5">
      <div className="flex items-center justify-between">
        <Label className="text-xs">{label}</Label>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => void copyToClipboard(command, copiedMessage)}
        >
          <Copy className="mr-2 h-3 w-3" />
          Copy
        </Button>
      </div>
      <pre className="max-h-44 overflow-auto rounded-md border bg-muted p-3 font-mono text-[11px] leading-relaxed">
        {command}
      </pre>
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
